<template>
  <section class="history">
    <h6 class="ms-1 mb-5 mt-2 text-gray-700">История</h6>
    <div v-if="hasHistory" class="rounded border bg-white info-panel custom-table">
      <div class="table-responsive">
        <table
          class="podft table table-striped table-hover table-row-dashed fs-8 table-row-gray-300 gy-3 mb-0 text-gray-800"
          style="white-space: nowrap !important;"
        >
          <thead>
            <tr class="fw-bold fs-8 text-gray-400">
              <th>Номер договора</th>
              <th class="w-95px">Продукт</th>
              <th v-if="showPremiumColumn">Премия</th>
              <th v-if="showRefundColumn">Возврат</th>
              <th v-if="showClientTitle">Страхователь</th>
              <th>Статус</th>
              <th>Срок действия</th>
              <th>Дата создания</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in history.data" :key="key" class="align-middle">
              <td>{{ item.global }}</td>
              <td>{{ item.product }}</td>
              <td v-if="showPremiumColumn">{{ item.premium ? item.premium.toLocaleString('ru-RU') + ' тг.' : '' }}</td>
              <td v-if="showRefundColumn">{{ item.refund ? item.refund.toLocaleString('ru-RU') + ' тг.' : '' }}</td>
              <td v-if="showClientTitle">{{ item.client_title }}</td>
              <td>{{ item.status }}</td>
              <td>
                <span class="text-primary">{{ item.date_from }}</span> - <span class="text-danger">{{ item.date_to }}</span>
              </td>
              <td>{{ item.created_at }}</td>
              <td class="text-end">
                <slot name="actions" :item="item" :index="key" />
              </td>
            </tr>
          </tbody>
        </table>
        <bootstrap5-pagination
          v-if="history"
          class="pagination-outline pt-3 mb-3 border-top"
          :limit="5"
          :data="history"
          @pagination-change-page="$emit('page-change', $event)"
        />
      </div>
    </div>
    <div v-else class="d-flex justify-content-center align-items-center rounded border bg-white info-panel fs-6 text-gray-400 custom-table h-200px">
      Нет информации
    </div>
  </section>
</template>

<script>
import { Bootstrap5Pagination } from 'laravel-vue-pagination'

export default {
  name: 'PolicyHistoryTable',
  components: {
    Bootstrap5Pagination
  },
  props: {
    history: {
      type: Object,
      default: null
    }
  },
  emits: ['page-change'],
  computed: {
    // Template for future history types: add a type key and override needed columns.
    historyColumnsByType() {
      return {
        5: {
          premium: true,
          refund: true,
          clientTitle: false
        },
        7: {
          premium: false,
          refund: false,
          clientTitle: true
        }
      }
    },
    hasHistory() {
      return this.history && Array.isArray(this.history.data) && this.history.data.length > 0
    },
    historyType() {
      if (!this.hasHistory) {
        return null
      }

      const types = [...new Set(this.history.data.map((item) => Number(item.type)))]
      return types.length === 1 ? types[0] : null
    },
    activeColumns() {
      const defaultColumns = {
        premium: true,
        refund: true,
        clientTitle: true
      }

      if (this.historyType === null) {
        return defaultColumns
      }

      return {
        ...defaultColumns,
        ...(this.historyColumnsByType[this.historyType] || {})
      }
    },
    showPremiumColumn() {
      return this.activeColumns.premium
    },
    showRefundColumn() {
      return this.activeColumns.refund
    },
    showClientTitle() {
      return this.activeColumns.clientTitle
    }
  }
}
</script>
